import React, { useEffect, useState } from 'react';
import './ClientIpAddress.css';

const ispAbbreviations = {
    'Korea Telecom': 'KT',
    'SK Broadband': 'SKB',
    'LG Uplus': 'LGU',
    'KT Corporation': 'KT',
    'SK Telecom': 'SKT'
    // Add more mappings as needed
};

const ClientIpAddress = () => {
    const [ipInfo, setIpInfo] = useState({
        ip: '',
        country: '',
        region: '',
        city: '',
        isp: ''
    });

    useEffect(() => {
        const getLocationInfo = async () => {
            try {
                const response = await fetch('https://ipapi.co/json/');
                const data = await response.json();
                const isp = data.org;
                const ispAbbreviation = ispAbbreviations[isp] ? ` (${ispAbbreviations[isp]})` : '';

                setIpInfo({
                    ip: data.ip,
                    country: data.country_name,
                    region: data.region,
                    city: data.city,
                    isp: `${isp}${ispAbbreviation}`
                });
            } catch (error) {
                console.error('Error fetching IP info:', error);
            }
        };

        getLocationInfo();
    }, []);

    return (
        <div className="container">
            <h2>Client IP Address</h2>
            <p className="rainbow-text">Made by 규성</p>
            <p>당신의 실제 IP 주소와 대략적인 위치 정보 :)</p>
            <p>당신의 IP 주소: {ipInfo.ip}</p>
            <p>당신의 인터넷 통신사: {ipInfo.isp}</p>
            <p>당신의 국가: {ipInfo.country}</p>
            <p>당신의 지역(정학하지 않을수있음): {ipInfo.region}</p>
            <p>당신의 도시(정학하지 않을수있음): {ipInfo.city}</p>
        </div>
    );
};

export default ClientIpAddress;
